import { useEffect, useState } from "react";
import UseWindowSize from "../UseWindowSize";

type BlogBannerProps = {
  img: string;
  alt: string;
};

const BlogBanner = ({ img, alt }: BlogBannerProps) => {
  const { width } = UseWindowSize();
  const [winSize, setWinSize] = useState(null);

  useEffect(() => {
    setWinSize(width);
  });

  return (
    <>
      <div className="detail-promo-banner">
        <img src={img + "?w=" + winSize * 1.2} alt={alt} />
      </div>
      <style jsx>{`
        .detail-promo-banner {
          height: auto;
        }
        .detail-promo-banner img {
          width: 100%;
          height: 100%;
          min-height: 120px;
        }
      `}</style>
    </>
  );
};

export { BlogBanner };
